module.exports = __webpack_public_path__ + "static/media/halugen-kit-items-mobile.c06bb3c2.png";